"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PINPhoneInput = void 0;
var React = __importStar(require("react"));
var PropTypes = __importStar(require("prop-types"));
var react_phone_input_2_1 = __importDefault(require("react-phone-input-2"));
var PINInput_1 = require("./PINInput");
require("react-phone-input-2/lib/style.css");
var PINPhoneInput = /** @class */ (function (_super) {
    __extends(PINPhoneInput, _super);
    function PINPhoneInput() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            value: _this.props.value || (typeof _this.props.defaultValue === "string"
                ? { phoneNumber: _this.props.defaultValue }
                : _this.props.defaultValue) || {},
            error: null
        };
        _this.getValueOnChange = function (hardValue, countryData) {
            var value = {
                phoneNumber: hardValue.replace("+", "").replace(countryData.dialCode, "")
                    .replace(/\s/g, ""),
                countryCode: "+" + countryData.dialCode
            };
            _this.setState({ value: value });
            return value;
        };
        return _this;
    }
    // @ts-expect-error ts-migrate(2416) FIXME: Property 'render' in type 'PINPhoneInput' is not a... Remove this comment to see the full error message
    PINPhoneInput.prototype.render = function () {
        var _a = this.props, hiddenRequired = _a.hiddenRequired, error = _a.error, label = _a.label, className = _a.className, type = _a.type, secure = _a.secure, id = _a.id, validation = _a.validation, onChange = _a.onChange, onChangeForm = _a.onChangeForm, onChangeDefault = _a.onChangeDefault, t = _a.t, specialLabel = _a.specialLabel, attr = __rest(_a, ["hiddenRequired", "error", "label", "className", "type", "secure", "id", "validation", "onChange", "onChangeForm", "onChangeDefault", "t", "specialLabel"]);
        var finalLabel = ((attr.required && !hiddenRequired) ? "* " : "") + (label || "");
        var inputClassName = "pinphoneinput-input" + ((error || this.state.error) ? " error" : "");
        return (React.createElement("div", { className: "pinphoneinput " + (className || "") },
            React.createElement("div", { className: "pinphoneinput-head" },
                React.createElement("label", { className: "pinphoneinput-label", htmlFor: id || attr.name }, finalLabel)),
            React.createElement(react_phone_input_2_1.default, __assign({}, attr, { 
                // @ts-expect-error ts-migrate(2322) FIXME: Type '{ className: any; preferredCountries: string... Remove this comment to see the full error message
                className: this.props.className, preferredCountries: ["fr"], defaultCountry: "fr", onChange: this.onChange, required: this.props.required, inputClass: inputClassName, value: "" + this.state.value.countryCode + this.state.value.phoneNumber, countryCodeEditable: false, specialLabel: specialLabel || "" })),
            (error || this.state.error)
                && React.createElement("div", { className: "pinphoneinput-error" }, error || this.state.error)));
    };
    PINPhoneInput.className = "PINPhoneInput";
    PINPhoneInput.propTypes = __assign(__assign({}, PINInput_1.PINInput.propTypes), { secure: PropTypes.bool });
    return PINPhoneInput;
}(PINInput_1.PINInput));
exports.PINPhoneInput = PINPhoneInput;
//# sourceMappingURL=PINPhoneInput.js.map